import axios from "axios";

class RepseService {
  constructor(apiUrl) {
    this.apiUrl = apiUrl;
  }

  /**
   * @author Edgar Escobedo
   * @description Get all Repse companies and their contractors
   * @date 17-04-2023
   * @param {String} token
   * @param {String} year
   * @returns {Object}
   * @memberof RepseService
   */
  async getAllRepseCompanies(token, year) {
    let response = await axios.get(`${this.apiUrl}/compliance-repse`, {
      params: {
        year,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  }

  /**
   * @author Adriana Fernandez
   * @description Get all Repse contracts and documents by contractor
   * @date 17-04-2023
   * @param {String} token
   * @param {String} contractorId
   * @param {String} year
   * @returns {Object}
   * @memberof RepseService
   */
  async getRepseContractsByContractor(token, contractorId, year) {
    let response = await axios.get(`${this.apiUrl}/status-repse-contract`, {
      params: {
        contractorId,
        year,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  }



  /**
  * @author Edgar Escobedo
  * @description Create or update a Repse document by contractorId, documentId, year, month
  * @date 17-04-2023
  * @param {Number} contractorId
  * @param {Number} documentId
  * @param {Number} year
  * @param {Number} month
  * @param {String} statusDocument
  * @param {File} repseDocument
  * @param {String} token
  * @returns {Object}
  * @memberof RepseService
  */
  async createDocumentRepset(repseDocument, token) {
    let response = await axios.post(
      `${this.apiUrl}/repse-document`,
      repseDocument,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  }


  /**
 * @author Edgar Escobedo
 * @description Get all documents Repse by contractorId and year
 * @date 18-04-2023
 * @param {Number} contractorId
 * @param {Number} year
 * @param {String} token
 * @returns {Object}
 * @memberof RepseService
 */
  async getAllRepseDocumentsByContractorId(contractorId, token) {
    let documents = await axios.get(`${this.apiUrl}/contractor-repse-documents?contractorId=${contractorId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
    return documents.data
  }

  /**
  * @author Adriana Fernandez
  * @description Get url of a file based on its path
  * @date 19-04-2023
  * @param {String} token
  * @param {String} documentPath
  * @returns {Object}
  * @memberof RepseService
  */
  async getDocumentUrl(token, documentPath) {
    let response = await axios.post(
      `${this.apiUrl}/get-url-document`,
      { documentPath },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }

  /**
 * @author Edgar Escobedo
 * @description Get all documents Repse details
 * @date 17-04-2023
 * @param {String} token
 * @param {Number} year
 * @returns {Object}
 * @memberof RepseService
 */
  async getDocuments(contractorId, year, month, token) {
    let response = await axios.get(
      `${this.apiUrl}/documents-repse?contractorId=${contractorId}&year=${year}&month=${month}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }


  /**
 * @author Edgar Escobedo
 * @description Create relation between contractor and company by ids
 * @date 21-04-2023
 * @param {String} contractorId
 * @param {String} companyId
 * @param {String} token
 * @returns {Object}
 * @memberof RepseService
 */
  async createRelationCompanyContractor(contractorId, companyId, token) {
    let response = await axios.post(`${this.apiUrl}/company-contractor`,
      {
        contractorId, companyId
      },
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    )
    return response.data
  }

  /**
 * @author Edgar Escobedo
 * @description Create or update contractRepse
 * @date 04-08-2023
 * @param {string} id
 * @param {String} name
 * @param {String} reference
 * @param {date} startDate
 * @param {date} endDate
 * @param {uuid} companyId
 * @param {number} contractorId
 * @param {string} contractReason
 * @param {number} vaultId
 * @param {String} token
 * @returns {Object}
 * @memberof RepseService
 */
  async createUpdateContractRepse(id, nameContract, reference, startDate, endDate, companyId, contractorId, contractReason, vaultId, paths, token){
    let response = await axios.post(`${this.apiUrl}/contract-repse`,
    {
      id,  nameContract, reference, startDate, endDate, companyId, contractorId, contractReason, vaultId, paths },
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )
  return response.data
  }

 /**
 * @author Edgar Escobedo
 * @description get repseContractDocuments
 * @date 07-08-2023
 * @param {number} repseContractId
 * @param {String} token
 * @returns {Object}
 * @memberof RepseService
 */
  async getRepseContractDocuments (repseContractId, token){
    let response = await axios.get(`${this.apiUrl}/repse-contract-documents?repseContractId=${repseContractId}`,
      {
        headers:{
          Authorization: `Bearer ${token}`
        }
      },
    )
    return response.data
  }

/**
 * @author Edgar Escobedo
 * @description upload repseContractDocuments
 * @date 08-08-2023
 * @param {number} id
 * @param {number} documentId
 * @param {number} statusId 
 * @param {number} repseContractId 
 * @param {files} documentContract 
 * @param {String} token
 * @returns {Object}
 * @memberof RepseService
 */
  async uploadRepseContractDocument(documentContract, token){
    let response = await axios.post(`${this.apiUrl}/repse-contract-documents`,
      documentContract
      ,
      {
        headers:{
          Authorization: `Bearer ${token}`
        }
      }
    )
    return response.data
  }

 

  /**
 * @author Edgar Escobedo
 * @description delete a repse contract
 * @date 07-08-2023
 * @param {number} id
 * @param {String} token
 * @returns {Object}
 * @memberof RepseService
 */
  async deleteRepseContract(id, token){
    let response = await axios.delete(`${this.apiUrl}/contract-repse?id=${id}`,
      {
        headers:{
          Authorization: `Bearer ${token}`
        }
      }
    )
    return response.data
  }
}

export { RepseService as default };
